import * as React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import ProtectedRoute from "./features/ProtectedRoute";
import Login from "./features/Login";
import ReportsPage from "./screens/ReportsPage";
import AdminPage from "./screens/AdminPage";
// import RegistrationInformationPage from "./screens/RegistrationInformationPage";
import HomeScreen from "./screens/HomePage";
import GroupListingScreen from "./screens/GroupListingPage";
import EventScreen from "./screens/EventPage";
import InstallationPage from "./screens/InstallationPage";
import ForgotPassword from "./features/ForgotPassword";
import ResetPassword from "./features/ResetPassword";
import AcceptRegisterTerm from "./features/AcceptRegisterTerm";
import FaqPage from "./screens/FaqPage";
import RouteListener from "./features/RouteListener";
import EditAdminPage from "./screens/EditAdminPage";
import SearchPage from "./screens/SearchPage";
import {
  PERMISSION_ACCESS_ADMIN,
  PERMISSION_ACCESS_BASE,
  PERMISSION_ACCESS_CONSUMPTION_CHART,
  PERMISSION_ACCESS_CONSUMPTION_HISTORY,
  PERMISSION_ACCESS_CONSUMPTION_REPORT,
  PERMISSION_ACCESS_INFORM_LEVEL,
  PERMISSION_ACCESS_LEVEL_CHART,
  PERMISSION_ACCESS_LEVEL_HISTORY,
  PERMISSION_ACCESS_LEVEL_REPORT,
} from "./core/models/Permission";
import EditGroupPage from "./screens/EditGroupPage";
import ClientPage from "./screens/ClientPage";

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <ProtectedRoute
          path="/home/"
          component={HomeScreen}
          permissionType={PERMISSION_ACCESS_BASE}
        />
        <ProtectedRoute
          path="/event/:businessEvent_id?"
          component={EventScreen}
          permissionType={PERMISSION_ACCESS_BASE}
        />
        <ProtectedRoute
          path="/group/:group_id"
          component={EditGroupPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
        />
        <ProtectedRoute
          path="/clients/"
          component={ClientPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
        />
        {/* <ProtectedRoute path="/faq/" component={FaqPage} permissionType={PERMISSION_ACCESS_BASE} /> */}
        <ProtectedRoute
          path="/groups/"
          component={GroupListingScreen}
          permissionType={PERMISSION_ACCESS_ADMIN}
        />
        <Route exact path="/" component={Login} />
        <Route exact path="/expired_token/">
          <Login expiredToken />
        </Route>
        <Route exact path="/forgot_password/" component={ForgotPassword} />
        <Route exact path="/reset/:token/" component={ResetPassword} />
        <Route exact path="/accept_register_term/:token/" component={AcceptRegisterTerm} />
      </Switch>
      {/* Global Re-router */}
      <RouteListener />
    </BrowserRouter>
  );
}

export default Routes;
